import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import React, { memo } from 'react';

const Component: React.FC<TooltipProps> = ({ children, ...props }) => {
  return (
    <MuiTooltip
      {...props}
      placement="top-start"
      slotProps={{
        tooltip: {
          sx: {
            height: '30px',
            fontSize: '12px',
            fontWeight: '400',
            color: 'var(--gray-2-color)',
            backgroundColor: 'var(--white-color)',
            border: '1px solid var(--gray-6-color)',
            boxShadow: '0px 4px 4px 0px var(--black-color-25)',
            padding: '8px 12px',
          },
        },
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-17, -7],
              },
            },
          ],
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
};

export const Tooltip = memo(Component);
